import { estLeSuperAdmin, estSuperAdmin } from '../constants/roles.js';
/** Un texte court : ce qu'on lit sur une ligne de liste. */
export const NOTE_CHARGEE_MAX = 300;
/**
 * L'accueil l'écrit (« Accueil + caisse » compris : le rôle de base fait foi),
 * et LE Super administrateur natif, qui fait tous les gestes (décision 433) —
 * jamais un dérivé de sa base. L'un et l'autre depuis un centre : l'appelant
 * vérifie le site.
 */
export function peutEcrireNoteChargee(compte, 
/** `FONCTION_SUPER_ADMIN_PARTOUT` (décision 436) : éteinte, l'accueil seul, comme en v1.0.1. */
superAdminPartout) {
    return compte.role === 'AGENT_ACCUEIL' || (superAdminPartout && estLeSuperAdmin(compte));
}
/**
 * La chargée, la Direction et le Super administrateur (décision 418) la
 * lisent partout ; l'accueil, celle de son centre. L'écrire reste un geste de
 * l'accueil au comptoir : une identité, pas un droit.
 */
export function peutLireNoteChargee(role) {
    return (estSuperAdmin(role) ||
        role === 'AGENT_ACCUEIL' ||
        role === 'CHARGE_CLIENTELE' ||
        role === 'DIRECTION');
}
/** Modifiable tant que la chargée n'a pas répondu ; ensuite figée. */
export function noteChargeeModifiable(etatConfirmation) {
    return etatConfirmation === 'A_CONFIRMER';
}
//# sourceMappingURL=note-chargee.js.map